var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 info-block",class:{ senior: _vm.isSenior, alumni: _vm.isAlumni}},[_c('div',{staticClass:"well"},[_c('p',[_vm._t("subtitle")],2)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }